// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style_pageWrapper__2u5vZ","poweredByLink":"style_poweredByLink__dW5xv","noData":"style_noData__3hxrT","reviewImage":"style_reviewImage__3nSfw"};